import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  fundingNewVehicleMatchData,
  transformData,
} from "../common/constants/commonFunction";
import { useModel, useNewVehicle } from "../common/hooks";
import { layoutStyle } from "../pages/layout-ui/style";
import { ActionFormFundingNewVehicle } from "./Funding-New-Vehicle/SetAllDataNewVehicleForm";
import { FUNDING_NEW_VEHICLE_CONSTANT } from "../common/constants/popupMessage";
import { ModelSelect } from "./ModelSelect";
import ComtracCalculationModal from "./ComtracCalculationModal";

const AddActionDialogNewVehicle = ({
  modalContent,
  closeModal,
  selectedRows,
  dropdownValue,
  keyValue,
  companyId,
  dealerId,
  setSelectedRows,
}) => {
  const classes = layoutStyle();
  const { multipleNewVehicleApi } = useNewVehicle();
  const { modelData, getModelList } = useModel();
  const [payloadValue, setPayloadValue] = useState();
  const [dropDownValue, setDropDownValue] = useState([]);
  const [textFieldValue, setTextFieldValue] = useState("");
  const [yearValue, setYearValue] = useState();
  const [yearName, setYearName] = useState();
  const [makeValue, setMakeValue] = useState();
  const [makeName, setMakeName] = useState();
  const [modelValueData, setModelValueData] = useState({
    modelId: null,
    model: "",
  });
  const [modelCsv, setModelCsv] = useState();
  const [mpgData, setMpgData] = useState();
  const [newAdd, setNewAdd] = useState("");
  const [setAllSavedSections, setSetAllSavedSections] = useState({
    vehicle: false,
    comtrac: false,
  });

  useEffect(() => {
    setSetAllSavedSections({ vehicle: false, comtrac: false });
  }, [modalContent]);

  useEffect(() => {
    if (setAllSavedSections.vehicle && setAllSavedSections.comtrac) {
      closeModal();
    }
  }, [setAllSavedSections, closeModal]);

  const handleSetAllSectionSaved = (section) => {
    setSetAllSavedSections((savedSections) => {
      return { ...savedSections, [section]: true };
    });
  };

  useEffect(() => {
    if (selectedRows[0]?.newMakeId && selectedRows[0]?.newYearId) {
      getModelList({
        makeId: selectedRows[0]?.newMakeId,
        yearId: selectedRows[0]?.newYearId,
      });
    } else {
      setDropDownValue([]);
    }
  }, [selectedRows[0]?.newMakeId && selectedRows[0]?.newYearId]);

  useEffect(() => {
    if (modelData?.length > 0) {
      setDropDownValue([...modelData]);
    }
    if (dropdownValue?.length > 0) {
      setDropDownValue([...dropdownValue]);
    }
  }, [modelData, dropdownValue]);

  const handleChangeTextField = async (event) => {
    const value = event.target.value;
    let editPayload = {};
    let equityGain = {};
    let ids = selectedRows?.map((items) => items.newVehicleId || items.id);
    if (modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_PAYMENT_AMOUNT) {
      equityGain = selectedRows?.map((items) => {
        const resale = Number(items.newEstimatedResaleValue) || 0;
        const cost = Number(items.newVehicleCost) || 0;
        const resPct = Number(items.residualPercentage) || 0;
        return parseFloat((resale - cost * (resPct / 100)).toFixed(2));
      });
      const transformedData = transformData(ids, equityGain);
      editPayload = {
        updateIds: transformedData.map((item) => ({
          ...item,
          paymentAmount: Number(value),
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_COST
    ) {
      equityGain = selectedRows?.map((items) => {
        const resale = Number(items.newEstimatedResaleValue) || 0;
        const cost = Number(value) || 0;
        const resPct = Number(items.residualPercentage) || 0;
        return parseFloat((resale - cost * (resPct / 100)).toFixed(2));
      });
      const transformedData = transformData(ids, equityGain);

      editPayload = {
        updateIds: transformedData.map((item) => ({
          ...item,
          newVehicleCost: Number(value),
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MPG
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          mpg: Number(value),
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_FUEL
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          newFuelId: value,
        })),
      };
    } else if (modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_RESIDUAL) {
      equityGain = selectedRows?.map((items) => {
        const resale = Number(items.newEstimatedResaleValue) || 0;
        const cost = Number(items.newVehicleCost) || 0;
        const resPct = Number(value) || 0;
        return parseFloat((resale - cost * (resPct / 100)).toFixed(2));
      });

      const transformedData = transformData(ids, equityGain);

      editPayload = {
        updateIds: transformedData.map((item) => ({
          ...item,
          residualPercentage: Number(value),
        })),
      };
    } else if (
      modalContent ===
      FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_ESTIMATES_RESALE_VALUE
    ) {
      equityGain = selectedRows?.map((items) => {
        const resale = Number(value) || 0;
        const cost = Number(items.newVehicleCost) || 0;
        const resPct = Number(items.residualPercentage) || 0;
        return parseFloat((resale - cost * (resPct / 100)).toFixed(2));
      });

      const transformedData = transformData(ids, equityGain);
      editPayload = {
        updateIds: transformedData.map((item) => ({
          ...item,
          newEstimatedResaleValue: Number(value),
        })),
      };
    }

    const finalPayload = {
      ...editPayload,
      companyId: companyId,
      dealerId: dealerId,
    };
    setTextFieldValue(value);
    setPayloadValue(finalPayload);
  };

  const handleChangeFleet = async (event, value) => {
    let editPayload = {};
    let ids = selectedRows?.map((items) => items.newVehicleId);
    if (modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_FUNDING_TYPE) {
      if (
        value?.fundingType === FUNDING_NEW_VEHICLE_CONSTANT.APR ||
        value?.fundingType === FUNDING_NEW_VEHICLE_CONSTANT.CASH
      ) {
        editPayload = {
          updateIds: ids.map((item) => ({
            id: item,
            fundingTypeId: value?.id,
            residualPercentage: 0,
            equityGain: 0,
          })),
        };
      } else if (value?.fundingType === FUNDING_NEW_VEHICLE_CONSTANT.LEASE) {
        editPayload = {
          updateIds: ids.map((item) => ({
            id: item,
            fundingTypeId: value?.id,
          })),
        };
      }
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MAKE
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          makeId: value?.id,
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          modelId: value?.modelId,
          mpg: value?.mpg,
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_YEAR
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          yearId: value?.id,
        })),
      };
    } else if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_FUEL
    ) {
      editPayload = {
        updateIds: ids.map((item) => ({
          id: item,
          newFuelId: value?.id,
        })),
      };
    }
    const finalPayload = {
      ...editPayload,
      companyId: companyId,
      dealerId: dealerId,
    };
    setPayloadValue(finalPayload);
  };

  const handleClickAuto = async () => {
    let payload = {
      year: yearValue,
      make: makeValue,
      modelId: modelValueData?.modelId,
      model: modelValueData?.model,
      newAdd: newAdd,
    };
    let payloadValues;
    if (modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL) {
      let ids = selectedRows?.map((items) => items.newVehicleId);
      payloadValues = {
        updateIds: ids.map((item) => ({
          id: item,
          modelId: modelValueData?.modelId,
        })),
        companyId: companyId,
        dealerId: dealerId,
      };
    }
    let yearValueId = selectedRows?.length > 0 ? selectedRows[0]?.yearId : null;
    let payload23 = {
      year: yearValueId,
      make: makeValue,
      modelId: modelValueData?.modelId,
      model: modelValueData?.model,
      newAdd: newAdd,
    };
    const payloadValuesFinal = payloadValues ? payloadValues : payloadValue;
    await multipleNewVehicleApi({
      values: payloadValuesFinal,
      newAdd: payload23,
    });
    setTextFieldValue("");
    setSelectedRows([]);
    closeModal();
  };
  useEffect(() => {
    if (
      modalContent === FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL &&
      selectedRows?.length > 0
    ) {
      let selectRow = selectedRows[0];
      setYearValue(selectRow.yearId);
      setMakeValue(selectRow.makeId);
    }
  }, [selectedRows, modalContent]);
  return (
    <Box>
      <Dialog
        open={!!modalContent}
        onClose={closeModal}
        maxWidth={
          modalContent === FUNDING_NEW_VEHICLE_CONSTANT.COMTRAC_CALCULATION
            ? "lg"
            : modalContent === "Set All"
              ? "lg"
              : "sm"
        }
        fullWidth
        PaperProps={{
          sx: (theme) => ({
            maxWidth:
              modalContent === FUNDING_NEW_VEHICLE_CONSTANT.COMTRAC_CALCULATION ||
                modalContent === "Set All"
                ? "1150px !important"
                : undefined,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderRadius: "16px",
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.12)' : 'rgba(160, 198, 232, 0.35)'}`,
            boxShadow: theme.palette.mode === 'dark' ? '0 16px 40px rgba(0,0,0,0.6)' : '0 16px 40px rgba(2, 6, 23, 0.08)',
            p: 1.5,
            "& .MuiInput-underline:before": { borderBottomColor: "rgba(160, 198, 232, 0.35) !important" },
            "& .MuiInput-underline:after": { borderBottomColor: "#208DE9 !important" },
            "& .MuiInput-root:before": { borderBottomColor: "rgba(160, 198, 232, 0.35) !important" },
            "& .MuiInput-root:after": { borderBottomColor: "#208DE9 !important" },
            "& .MuiInput-root:hover:not(.Mui-disabled):before": { borderBottomColor: "#208DE9 !important" },
          })
        }}
      >
        <DialogTitle
          id="modal-title"
          sx={{
            m: 0,
            p: 2,
            fontWeight: 700,
            color: "#0860D3",
            borderBottom: "1px solid rgba(160, 198, 232, 0.35)",
          }}
        >
          {modalContent}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={closeModal}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#94A3B8",
            "&:hover": { color: "#F1F5F9" }
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ mt: 2 }}>
          {modalContent !== "Set All" &&
            modalContent !== FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL &&
            modalContent !== FUNDING_NEW_VEHICLE_CONSTANT.COMTRAC_CALCULATION ? (
            <>
              <Box className={classes.actionDialog} sx={{ width: "100%", mb: 3 }}>
                <Box className={classes.dailogTitleInput} sx={(theme) => ({ color: theme.palette.text.primary, fontWeight: 600, width: "30%" })}>{modalContent}</Box>

                <Box style={{ width: "70%" }}>
                  {fundingNewVehicleMatchData.includes(modalContent) ? (
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={dropDownValue}
                      fullWidth
                      getOptionLabel={(option) => option[keyValue]}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {option[keyValue]}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          sx={(theme) => ({
                            input: { color: theme.palette.text.primary },
                            "& .MuiInput-underline:before": { borderBottomColor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.2)" },
                            "& .MuiInput-underline:after": { borderBottomColor: "#0860d3" }
                          })}
                        />
                      )}
                      onChange={handleChangeFleet}
                    />
                  ) : (
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      sx={(theme) => ({
                        width: "100%",
                        input: { color: theme.palette.text.primary },
                        "& .MuiInput-underline:before": { borderBottomColor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.2)" },
                        "& .MuiInput-underline:after": { borderBottomColor: "#0860d3" }
                      })}
                      value={textFieldValue}
                      onChange={handleChangeTextField}
                    />
                  )}
                </Box>
              </Box>
              <Box className={classes.actionButtonDialog} sx={{ mt: 3, display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <Button
                  onClick={() => closeModal()}
                  className={classes.addActionButton}
                  sx={{
                    color: "#CBD5E1 !important",
                    borderColor: "rgba(203, 213, 225, 0.3) !important",
                    borderRadius: "8px !important",
                    textTransform: "capitalize !important",
                    background: "rgba(203, 213, 225, 0.05) !important",
                    boxShadow: "none !important",
                    "&:hover": { background: "rgba(203, 213, 225, 0.15) !important" }
                  }}
                >
                  Back
                </Button>
                <Button
                  className={classes.addActionButton}
                  onClick={handleClickAuto}
                  sx={{
                    borderRadius: "8px !important",
                    textTransform: "capitalize !important",
                  }}
                >
                  Save
                </Button>
              </Box>
            </>
          ) : modalContent ===
            FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL ? (
            <>
              <ModelSelect
                makeValue={makeValue}
                modelValueData={dropdownValue}
                setModelValueData={setModelValueData}
                setMpgData={setMpgData}
                yearValue={yearValue}
                setModelCsv={setModelCsv}
                width={500}
                setNewAdd={setNewAdd}
                actionModel={true}
              />
              <Box className={classes.actionButtonDialog} sx={{ mt: 3, display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <Button
                  onClick={() => closeModal()}
                  className={classes.addActionButton}
                  sx={{
                    color: "#CBD5E1 !important",
                    borderColor: "rgba(203, 213, 225, 0.3) !important",
                    borderRadius: "8px !important",
                    textTransform: "capitalize !important",
                    background: "rgba(203, 213, 225, 0.05) !important",
                    boxShadow: "none !important",
                    "&:hover": { background: "rgba(203, 213, 225, 0.15) !important" }
                  }}
                >
                  Back
                </Button>
                <Button
                  className={classes.addActionButton}
                  onClick={handleClickAuto}
                  sx={{
                    borderRadius: "8px !important",
                    textTransform: "capitalize !important",
                  }}
                >
                  Save
                </Button>
              </Box>
            </>
          ) : modalContent === "Set All" ? (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "minmax(0, 1fr)",
                  md: "minmax(0, 30fr) minmax(0, 70fr)",

                },
                gap: { xs: 2, md: 3 },
                alignItems: "start",
                width: "100%",
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <ActionFormFundingNewVehicle
                  dropdownValue={dropdownValue}
                  closeModal={
                    modalContent === "Set All"
                      ? () => handleSetAllSectionSaved("vehicle")
                      : closeModal
                  }
                  selectedRows={selectedRows}
                  dealerId={dealerId}
                  companyId={companyId}
                  setSelectedRows={setSelectedRows}
                />
              </Box>
              <Box sx={{ minWidth: 0, borderLeft: "1px solid #9B9FA2" }}>
                <ComtracCalculationModal
                  closeModal={
                    modalContent === "Set All"
                      ? () => handleSetAllSectionSaved("comtrac")
                      : closeModal
                  }
                  selectedRows={selectedRows}
                  companyId={companyId}
                  dealerId={dealerId}
                  setSelectedRows={setSelectedRows}
                />
              </Box>
            </Box>
          ) : null}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AddActionDialogNewVehicle;

